import { Box, Stack, Typography } from "@mui/material";
import { prefixClassName } from "@smartrr/shared/components/primitives";
import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";
import { ArrowBack } from "akar-icons";
import React from "react";

import { useSmartrrTheme } from "@customer-app/account/views/OperationAquarius/hooks/useSmartrrTheme";

import { PackBtn } from "../../../Bundles/PackBtn";
import { IPackSelectionProps } from "../types";

export const PackSelection = ({ activePack, bundle, setActivePack }: IPackSelectionProps) => {
  const theme = useSmartrrTheme();
  return (
    <Box
      className={prefixClassName("bundle-pack-selection")}
      data-testid={prefixClassName("bundle-pack-selection")}
      mt={"20px"}
    >
      <Typography variant="h4">{typedLocalize("editBundle.yourSize")}</Typography>
      <Stack spacing={"20px"} direction="row" display="flex" alignItems="end">
        {activePack ? (
          <React.Fragment>
            <PackBtn pack={activePack} activePack={activePack} setActivePack={setActivePack} />
            <Stack
              direction="row"
              spacing="5px"
              onClick={() => setActivePack(undefined)}
              sx={{ cursor: "pointer", marginLeft: "10px !important" }}
              className={prefixClassName("bundle-select-pack-size-button")}
              data-testid={prefixClassName("bundle-select-pack-size-button")}
            >
              <ArrowBack size={10} color={theme.modernIconsColor} />
              <Typography variant="caption1">{typedLocalize("editBundle.selectDifferentSize")}</Typography>
            </Stack>
          </React.Fragment>
        ) : (
          <Stack direction="row" display="flex" alignItems="start" spacing="20px">
            {bundle!.packs.map((pack, i) => (
              <PackBtn key={i} pack={pack} activePack={activePack} setActivePack={setActivePack} />
            ))}
          </Stack>
        )}
      </Stack>
    </Box>
  );
};
